import Component from '../core/Component';

export default class FormPoll extends Component {
    constructor(element) {
        super(element);

        this.ref = {
            errorContainer: null
        }
    }

    prepare() {
        this.timer = 0;

        this.element.addEventListener("nette:invalid", ::this.handleInValid);
        this.element.addEventListener("nette:valid", ::this.handleValid);
    }

    handleInValid(event) {
        event.stopPropagation();
        this.timer = Date.now();

        const message = event.target.getAttribute('data-nette-error');
        const error = document.createElement('div');
        error.classList.add('InputError');
        error.innerText = message;

        this.ref.errorContainer.appendChild(error);
    }

    handleValid(event) {
        event.stopPropagation();

        if (Date.now() < this.timer + 200) {
            return;
        }

        const error = this.element.querySelector('.InputError');

        if (error) {
            this.ref.errorContainer.removeChild(error);
        }
    }
}